export const TEST_IDS = {
  promptPlaceholder: 'prompt-placeholder',
} as const;
